export const REHEARSAL_LOW = 2;
export const REHEARSAL_DRAFT_KEY = "lawlow.rehearsalDraft";
export const REHEARSAL_RETURN_KEY = "lawlow.rehearsalReturn";

export const scenarios = [
  { id: "freelance", label: "외주 대금", description: "작업은 끝났는데 입금이 없어요.", subject: "작업 대금", example: "디자인 작업을 납품했고 약속한 입금일이 일주일 지났어요. 잔금 30만 원이 남아 있어요." },
  { id: "loan", label: "빌려준 돈", description: "다음 주에 준다는 말만 반복해요.", subject: "빌려드린 금액", example: "빌려준 20만 원을 지난주까지 돌려받기로 했는데 아직 받지 못했어요. 언제 받을 수 있는지 확인하고 싶어요." },
  { id: "deposit", label: "보증금", description: "반환 일정부터 확인하고 싶어요.", subject: "반환하기로 한 보증금", example: "이사를 마쳤고 약속한 보증금 반환일이 지났어요. 반환 가능한 날짜를 확인하고 싶어요." },
];

export const turns = [
  { title: "첫 연락을 어떻게 시작할까요?", reply: "확인하고 연락드릴게요.", options: ["약속한 입금일이 지나 연락드려요. 현재 지급 상황을 확인해 주세요.", "언제까지 기다려야 하나요?"], tips: ["약속한 사실부터 짚으면 요청이 또렷해져요.", "기다린 마음에 더해 약속한 날짜를 적어보세요."] },
  { title: "한 번 더 미루면?", reply: "이번 주는 좀 어려울 것 같아요.", options: ["그럼 가능한 날짜와 금액을 구체적으로 알려주세요.", "알겠어요. 준비되면 연락 주세요."], tips: ["날짜와 금액처럼 답할 수 있는 질문을 남겼어요.", "기한이 없으면 기다림이 길어질 수 있어요. 가능한 날짜를 물어보세요."] },
  { title: "마지막으로 무엇을 남길까요?", reply: "정확한 날짜는 아직 모르겠어요.", options: ["제가 정한 회신 희망일까지 지급 계획을 알려주세요. 합의한 내용은 문자로 남기고 싶어요.", "오늘 안 주면 주변에 다 알릴 거예요."], tips: ["회신을 원하는 날짜를 직접 정하고, 합의 내용을 기록으로 남겨보세요.", "신상 공개나 위협 대신 회신을 원하는 날짜와 요청 사항을 차분하게 남겨보세요."] },
];

export function readRehearsalDraft() {
  try {
    const draft = JSON.parse(sessionStorage.getItem(REHEARSAL_DRAFT_KEY));
    if (!draft || !scenarios.some((s) => s.id === draft.scenario) || !Array.isArray(draft.answers) || draft.answers.length > 3 || draft.answers.some((v) => v !== 0 && v !== 1)) return null;
    return draft;
  } catch (_) { return null; }
}

export function consumeRehearsalReturn(pathname, loggedIn) {
  if (!loggedIn || !["/main", "/app-guide"].includes(pathname)) return false;
  const value = sessionStorage.getItem(REHEARSAL_RETURN_KEY);
  if (!value) return false;
  sessionStorage.removeItem(REHEARSAL_RETURN_KEY);
  return Date.now() - Number(value) >= 0 && Date.now() - Number(value) < 30 * 60 * 1000;
}
